import React from 'react';
import Retreat from '../components/Retreat';

const RetreatPage = ({ onContactClick }) => {
  return (
    <>
      <Retreat onContactClick={onContactClick} />
    </>
  );
};

export default RetreatPage;
